export default {
  title: 'Are you sure you want to delete your account?',
  description:
    'This action is permanent. You’ll lose access to your orders, loyalty points, and any saved preferences.',
  labels: {
    loading: 'Deleting your account...',
  },
  buttons: {
    confirm: 'Confirm',
    cancel: 'Cancel',
  },
  toasts: {
    success:
      'Your account has been permanently deleted. You no longer have access to your order history, loyalty points, or saved data.',
    error:
      'Something went wrong. Please try again. If the problem persists, please contact our support team: {{supportEmail}}',
  },
};
